export default {
    BusinessPurchaseDetailPage: {
        order: '采购单状态',
        Receipt: '入库状态',
        quantity: '采购数量',
        Received: '已入库',
        Not: '未入库',
        Data: '数据容错量',
        Basic: '采购单基本信息',
        number: '采购单号',
        type: '采购类型',
        Receiving: '收货仓',
        Creation: '创建时间',
        Approval: '审核时间',
        Completion: '完成时间',
        Buyer: '采购员',
        requisi: '采购申请单号',
        Remarks: '备注',
        info: '商品信息',
        table: {
            Purchase: '采购数量',
            Quantity: '在产数量',
            transit: '在途数量',
            not: '未入库数量',
            Received: '已入库数量',
            Australian: '澳币采购价',
            Selling: '售价',
            Link: 'Link链接',
            Price: 'Link最低价格',
            Express: '快递费',
            Consumption: '消费税',
            Platform: '平台费用',
            Estimated: '预计利润',
            Expected: '预计利润率',
            Actual: '实际利润率',
            risk: '采购风险指示器',
            Barcode: '条形码',
            cartonBoxBarcode: '外箱条形码',
            brand: '产品品牌',
            Product1: '产品分类1',
            Product2: '产品分类2',
            Description: '产品描述',
            length: '商品长度',
            width: '商品宽度',
            high: '商品高度',
            Volume: '商品体积',
            Weight: '商品重量',
            boxLength: '纸箱长度',
            boxWidth: '纸箱宽度',
            boxheight: '纸箱高度',
            boxVolume: '纸箱体积',
            boxWeight: '纸箱重量',
            per: '每箱产品数量',
            Buyer: '采购员',
        },
        Associated: '关联单据',
        dataForm: {
            type: '关联单据类型',
            number: '采购入库单单号',
            status: '采购入库单状态',
            time: '创建时间',
            by: '创建人',
        },
        plantQtySum: '订货数量合计',
        productVolume: '产品总体积',
        cartonWeight: '纸箱总重量',
        contractNo: '合同号',
        planQty: '单据数量',
        signDate: '签约时间',
        execStatus: '执行状态',
        tab1: '商品明细',
        tab2: '商品关联合同',
    }
};
